/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCheckbold from '@telus-uds/palette-allium/build/rn/icons/Checkbold'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs', 'sm', 'md' ] },
      tokens: { borderWidth: 0, paddingHorizontal: 24, paddingVertical: 0 }
    }
  ],
  tokens: {
    borderColor: '#e3e6e8',
    borderRadius: 6,
    borderStyle: 'solid',
    borderWidth: 1,
    paddingHorizontal: 24,
    paddingVertical: 24,
    selectedButtonIcon: PaletteIconCheckbold
  }
}
export default theme
